import { BaseContainerModel } from "../base-container.model";
import { bl_fi_generic_doc_line_draft_lock_serial_number_RowClass } from "../../dbschema";

export class GenericDocLineDraftLockSerialNumberContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_line_draft_lock_serial_number: bl_fi_generic_doc_line_draft_lock_serial_number_RowClass =
    new bl_fi_generic_doc_line_draft_lock_serial_number_RowClass();
}
